<template>
  <div class="">
    <Law 
      :viewName="'viewName'"
    />
  </div>
</template>
<script>

import Law from '@/views/Law.vue'

export default {
  components: {
    Law
  },
  name: 'EnforcementLaw'
}
</script>